import Pusher from 'pusher-js';

// new hub envir
export const environment = {
    name: 'production',
    url: 'https://hub.qwykportals.com',
    badge: null,
    sentry: {
        enabled: true,
        dsn: 'https://ea089f67cc2643ed89a8db0135fbc0ef@sentry.io/4825874',
        traceOrigins: [
            'https://hub.qwykportals.com',
            'https://api.qwykportals.com',
        ],
        tracesSampleRate: 0.1,
    },
    debug: false,
    production: true,
    backendServer: 'https://api.qwykportals.com',
    schedulesBackend: 'https://api.qwykschedules.com',
    portalSitesMask: 'https://{0}.qwykportals.com',
    feedbackSite: 'https://magaya.ideas.aha.io',
    auth0: {
        domain: 'magaya-prod.us.auth0.com',
        clientId: 'uRiAi2o1plD9O5M87pfauPp6hWpe07t7',
        authorizationParams: {
            redirect_uri: 'https://hub.qwykportals.com/callback',
            audience: 'https://apps.qwyk.io',
        },
    },
    supportEmail: 'rmsupport@magaya.com',
    utils: {
        Algolia: {
            applicationId: '3G8S1ON0FI',
            adminApiKey: 'c397d91713a36b2e696eb4454f22ec40',
        },
        Echo: {
            userModel: 'App.Models.Hub.Auth.User',
            notificationNamespace: 'App\\Notifications',
            options: {
                broadcaster: 'pusher',
                key: '1af98dbec4d0647880bb',
                cluster: 'eu',
                forceTLS: true,
                authEndpoint:
                    'https://api.qwykportals.com/api/hub/broadcasting/auth',
                enabledTransports: ['ws', 'wss'],
                client: new Pusher('1af98dbec4d0647880bb', {
                    cluster: 'eu',
                    enabledTransports: ['ws', 'wss'],
                    authEndpoint:
                        'https://api.qwykportals.com/api/hub/broadcasting/auth',
                }),
            },
        },
        Veem: {
            environment: 'production',
            clientId: 'MagayaDigitalFreightPortal-nJO3BW8zqQ',
        },
        Amplitude: {
            enabled: false,
            apiKey: null,
        },
        Segment: {
            apiKey: 'G4i7Qbgws6CABI0XCfPTZyeqzaH84kP7',
            debug: false,
            loadOnInitialization: true,
        },
    },
};
